<template>
  <div class="hot-tags-gay" v-if="getDisplayTags.length">
    <div class="tit" @click="showTags = !showTags">热门标签<span>{{ showTags ? '-' : '+' }}</span></div>
    <ul class="hot-tags-list">
      <li v-for="(item, index) in getDisplayTags" :key="`tag-${index}`" @click="$emit('actionHotTag', item)">
        <span class="tag-text">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts" name="HotTagsGay">
const globalStore = useGlobalStore();
const { appData }: any = storeToRefs(globalStore);
interface Props {
  status?: boolean,
  channel?: string
}
const props = withDefaults(defineProps<Props>(), {
  status: false, // 默认显示全部
  channel: 'search' // 应用场景 用来判断所要显示的数据
})
const showTags = ref(true)
showTags.value = props.status;
const getDisplayTags = computed(() => {
  const allTags = JSON.parse(JSON.stringify(appData.value?.allTags || []))
  const hotTags = JSON.parse(JSON.stringify(appData.value?.hotTags || []))

  let tags = allTags;
  if (props.channel == 'search') {
    tags = hotTags
  }
  let splicTags: any = []
  // if (showTags.value) {
  //   splicTags = tags
  // } else {
  //   splicTags = tags.length > 15 ? tags.slice(0, 15) : tags
  // }
  if (Array.isArray(tags)) {
    if (showTags.value) {
      splicTags = tags
    } else {
      splicTags = tags.length > 15 ? tags.slice(0, 15) : tags
    }
  } else {
    console.warn('tags is not array:', tags)
    splicTags = []
  }
  let lessTag = splicTags.length % 3;
  if (lessTag) {
    for (let i = 0; i < 3 - lessTag; i++) {
      splicTags.push({
        name: '',
        id: ''
      })
    }
  }
  return splicTags
})
</script>

<style lang="scss" scoped>
.hot-tags-gay {
  margin-bottom: 20px;

  .hot-tags-list {
    display: flex;
    flex-wrap: wrap;
    border-radius: 5px;
    border: 1px #000 solid;
    border-bottom: 0;
    // border-right: 0;
    overflow: hidden;

    li {
      width: 33.3333%;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      font-weight: 400;
      color: #000;
      border-bottom: 1px #000 solid;
      border-right: 1px #000 solid;

      &:nth-child(3n) {
        border-right: 0;
      }
    }
  }

  .tit {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    border-radius: 5px;
    border: 1px solid #000;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    margin-bottom: 15px;

    span {
      margin-left: 18px;
    }
  }
}
</style>
